// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"_2iKEs","buttonWrapper":"_2iKEs","full-width-button":"_11ubg","fullWidthButton":"_11ubg"};